import React from 'react';
import {useBuffetState} from '../components/buffet';
import useQuery from './use-query';
import {useSettingsState} from '../components/settings';

const useBuffetStateEx = () => {
    const {defaultServiceId} = useSettingsState();
    const {serviceId = defaultServiceId} = useQuery();
    const state = useBuffetState();
    return React.useMemo(() => state.filter(e => e.serviceId === serviceId), [state, serviceId]);
};

export default useBuffetStateEx;
